import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
   Navigate,
  useParams,
} from "react-router-dom";
import { Helmet } from "react-helmet";

import ScrollToTop from "./components/ScrollToTop";
import FloatingActions from "./components/FloatingActions";
import ContactSection from "./components/ContactSection";
import DynamicLandingPage from "./pages/DynamicLandingPage";

function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>Page Not Found | G1 Gold</title>
        <meta name="robots" content="noindex, follow" />
        <meta name="googlebot" content="noindex, follow" />
      </Helmet>

      <div style={{ padding: "80px 20px", textAlign: "center" }}>
        <h1>Page Not Found</h1>
        <p>The requested page is no longer available.</p>
      </div>
    </>
  );
}

function FloatingActionsAfterHydration() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // React Snap should serialize the same initial tree that the browser
    // hydrates. Show client-only floating actions only after hydration.
    if (!navigator.userAgent.includes("ReactSnap")) {
      setMounted(true);
    }
  }, []);

  return mounted ? <FloatingActions /> : null;
}

function BlankLandingRoot() {
  return null;
}
function SlugRouteHandler() {
  const { slug } = useParams();

  const isOldReleasePledgedGoldUrl =
    slug?.startsWith("release-pledged-gold-") &&
    !slug?.startsWith("release-pledged-gold-in-");

  if (isOldReleasePledgedGoldUrl) {
    const locationSlug = slug.replace(
      /^release-pledged-gold-/,
      ""
    );

    return (
      <Navigate
        to={`/release-pledged-gold-in-${locationSlug}`}
        replace
      />
    );
  }

  return <DynamicLandingPage />;
}
function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <FloatingActionsAfterHydration />

      <Routes>
        <Route path="/" element={<BlankLandingRoot />} />

        <Route
          path="/contact-us"
          element={<ContactSection />}
        />

        {/*
          All registered location URLs use the JSON filename convention:
          /:slug -> /data/branches/:slug.json

          This removes the extra branches-registry request from the runtime
          rendering path and avoids turning registry/network failures into
          false "Page Not Found" content.
        */}
        <Route
  path="/:slug"
  element={<SlugRouteHandler />}
/>

        <Route
          path="*"
          element={<NotFoundPage />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
